import { ReactLenis } from "@studio-freight/react-lenis";
import SEO from "../components/SEO";

//components
import TextImage from "../components/TextImage";
import Image from "../components/Image";

function Values() {
  const paragraphs = [
    {
        text: "I nostri Professionisti operano principalmente nell’ambito del diritto civile, commerciale e societario, ponendo sempre la massima attenzione alle esigenze del cliente.",
    },
    {
        text: "Lo Studio, sin dalla sua costituzione, collabora attivamente con professionisti ed imprese, assistendo i propri clienti in ogni aspetto e fase della vita societaria e d’impresa. In quest’ottica, sin dall’entrata in vigore del D. Lgs. 8 giugno 2001, n. 231, offre assistenza e consulenza alle società anche in materia di responsabilità amministrativa degli enti e di diritto penale delle imprese, garantendo un’assistenza completa, professionale ed attenta, avvalendosi, all’occorrenza, dei più accreditati consulenti specialistici nei diversi settori di riferimento.",
    },
    {
      text: "Rispetto, dedizione, preparazione tecnica, continuo aggiornamento ed accurato ascolto delle volontà e delle necessità di ciascun cliente sono tra i principi e valori ai quali maggiormente si ispira l’attività svolta dai Professionisti dello Studio. È nostra convinzione, infatti, che la ricerca della soluzione più adatta ai problemi rappresentati e ai quesiti posti richieda, oltre alle conoscenze tecniche, alla ricerca e allo studio della materia, anche accortezza, tempestività di intervento, avvedutezza e presenza costante.",
    },
    {
      text: "Lo Studio assiste numerose società, con sede in Italia ed all’estero, oltre a privati, offrendo un servizio a “trecentosessanta gradi”: dall’attività di consulenza extra-processuale, alla difesa ed assistenza giudiziale."
    },
    {
      text: "La conoscenza dell’inglese giuridico garantisce una qualificata assistenza anche a clienti stranieri, sia per attività di consulenza sia per la difesa processuale in relazione alle controversie rientranti nella giurisdizione italiana."
    }
  ];

  return (
    <ReactLenis root>
      <SEO
        title="Studio Legale Bevilacqua: Chi Siamo e i Nostri Valori"
        description="Lo Studio Legale Bevilacqua di Pordenone assiste imprese italiane ed estere e privati. Rispetto, dedizione e preparazione tecnica sono i nostri valori."
        canonical="/valori"
      />
      <div className="values">
        <Image src="/images/valori_page.jpg" alt="i nostri valori" />
        <TextImage
          title="I nostri valori"
          titleTag="h1"
          paragraphs={paragraphs}
        />
      </div>
    </ReactLenis>
  );
}

export default Values;